export const SymbolicAmount = Object.freeze({
    fullDay: -1,
    hours: -3,
    firstHalfDay: -4,
    secondHalfDay: -5
});
